module.exports = __webpack_public_path__ + "img/chevron-down.80bfd660.svg";